































import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'ZigZagLayout',
  props: {
    image: {
      type: String as PropType<string>,
      required: true,
    },
    isImageLeftSide: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
    imageExplainerText: {
      type: String as PropType<string>,
      required: true,
      default: '',
    },
    lazyLoad: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
  },
  setup(props) {
    const loadingAttribute = computed(() =>
      props.lazyLoad ? 'lazy' : 'eager'
    );

    return { loadingAttribute };
  },
});
